// extracted by mini-css-extract-plugin
export default {"settingsBlock":"settingsPage_settingsBlock__iJm0t","settingsBlockDirection":"settingsPage_settingsBlockDirection__1tLax"};